import { getReportQueue } from 'RestAPIs/report-queue';

import { BaseQueue } from 'components/admin-portal/queues/BaseQueue';

const ReportQueue = () => {
  const columns = [
    'id',
    'tenantId',
    'status',
    'inserted',
    'started',
    'ended',
    'accountId',
    'reportFileId'
  ];

  return (
    <BaseQueue
      queueName="reportQueue"
      columns={columns}
      getBaseQueue={getReportQueue}
    />
  );
};

export default ReportQueue;
